module.exports = __webpack_public_path__ + "static/media/close.1164b62d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/close.svg
// module id = 805
// module chunks = 2